import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbList: PageLink[] = [
  {
    title: 'Indicação',
    path: '/leads',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
